export default {"src":"/_next/static/media/wall.16b69928.svg","height":31,"width":33,"blurWidth":0,"blurHeight":0};